import { AppBar, ButtonBase, Container, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import CadsoftLogoMark from '../icons/CadsoftLogoMark'
import CircularProgress from '@mui/material/CircularProgress'
import Item from '../submodules/Item'
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close'
import LogoutIcon from '@mui/icons-material/Logout';

const Header = (props) => {

  const [searchQuery, setSearchQuery] = useState("");
  const [searchedItems, setSearchedItems] = useState([]);

  useEffect(() => {
    setSearchedItems(props.items.filter(item => item.name.toLowerCase().replace(" ", "").includes(searchQuery.toLowerCase().replace(" ", ""))));
    return () => {setSearchedItems([])};
  }, [searchQuery, props.items]);

  return (
    <Box>
      <AppBar sx={{backgroundColor: "white", justifyContent: "center",}} position="sticky">
        <Container maxWidth="xl">
          <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap",}}>
              <Box sx={{alignItems: "center", display: "flex", justifyContent: "center", marginRight: 5, marginY: 1.25}}>
                <ButtonBase href="https://www.cadsoft.com/" sx={{border: "1px solid transparent", pr: 1, '&:hover': { border: "1px solid black" }}}>
                <CadsoftLogoMark height={50} width={50}/>
                  <Box>
                    <Typography variant='h1' fontSize={30} fontWeight={600} color="#000">3D Library</Typography>
                    <Typography fontSize={14} fontWeight={300} color="#000">Home Design Software 3D Models</Typography>
                  </Box>
                </ButtonBase>
              </Box>
            <Box sx={{alignItems: "center", display: "flex", flex: 1, minWidth: 300,}}>
              <Box sx={{display: "flex", flex: 1, marginY: 1.25,}}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {
                          props.items.length === 0 ? <CircularProgress size={24} /> : <SearchIcon />
                        }
                      </InputAdornment>
                    ),
                    endAdornment: (
                      searchQuery.length > 0 ? (
                      <InputAdornment position="end">
                        <IconButton onClick={() => {setSearchQuery("")}}>
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                      ) : null
                    ),
                  }}
                  disabled={props.items.length === 0 ? true : false}
                  fullWidth
                  label="Search"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  placeholder="Search..."
                  value={searchQuery}
                />
              </Box>
              <Box sx={{marginLeft: 1,}}>
                <IconButton href="https://www.cadsoft.com">
                  <LogoutIcon/>
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Container>
      </AppBar>
      <Box sx={{height: 25,}}></Box>
      <Box>
        {
          searchQuery.length > 1 ? (
            <Container>
              <Typography variant="h2" fontSize={20} fontWeight="bold">Search Results:</Typography>
              <Box sx={{display: "flex", flexWrap: "wrap"}}>
                {
                  searchedItems.length > 0 ? (
                    searchedItems.slice(0,4).map(item => (
                      <Item item={item} key={item.id}/>
                    ))
                  ) : (
                    <Typography>No results.</Typography>
                  )
                }
              </Box>
              <Box sx={{height: 20,}}></Box>
            </Container>
          ) : null
        }
      </Box>
    </Box>
  )
}

export default Header